import React from 'react';
import { MessageCircle, Calendar, CheckCircle, Shield, Clock, Archive, Home, Building2 } from 'lucide-react';
import ServicePageLayout from '../components/ServicePageLayout';
import { P } from '../constants';

const data = {
  seo: {
    title: 'Kellerräumung Wien » Fixpreis ab €290 – Wohnungsräumung Wien',
    description: 'Kellerräumung Wien ab €290 ✓ Fixpreis ✓ Kurzfristige Termine ✓ Fachgerechte Entsorgung ✓ Besenrein. Dachboden & Kellerräumung Wien – jetzt anfragen!',
    keywords: 'Kellerräumung Wien, Kellerräumung Wien Kosten, Keller räumen Wien, Dachbodenräumung Wien, Kellerentrümpelung Wien',
    canonical: '/kellerraeumung-wien',
    h1short: 'Kellerräumung Wien',
  },
  schemas: [{
    '@context': 'https://schema.org',
    '@type': 'Service',
    'name': 'Kellerräumung Wien',
    'provider': { '@type': 'LocalBusiness', 'name': 'Wohnungsräumung Wien' },
    'areaServed': 'Wien',
    'description': 'Professionelle Kellerräumung und Dachbodenräumung in Wien. Ab €290 mit Fixpreisgarantie und besenreiner Übergabe.',
    'offers': { '@type': 'Offer', 'price': '290', 'priceCurrency': 'EUR' },
  }],
  hero: {
    badge: 'Ab €290 – sofort verfügbar',
    headline: <><span>Kellerräumung<br />Wien</span><br /><span className="text-[#E8722A]">ab €290 Fixpreis.</span></>,
    subline: 'Seit Jahren liegt der Kram da. Wir räumen ihn weg.',
    bullets: [
      'Einstiegspreis ab €290 – kleinste Keller sofort möglich',
      'Kostenlose Besichtigung & verbindlicher Fixpreis',
      'Fachgerechte Entsorgung – alles wird sortiert',
      'Besenreine Übergabe. Immer. Ohne Aufpreis.',
      'Kurzfristige Termine – oft noch diese Woche',
    ],
    imageSrc: P.boxesRack,
    imageAlt: 'Kellerräumung Wien – Voller Keller vor der Räumung',
  },
  formTitle: 'Kellerräumung anfragen –',
  serviceName: 'Kellerräumung',
  serviceCard: {
    heading: 'Kellerräumung Wien – Sie schieben es auf, wir erledigen es',
    paragraphs: [
      'Seit Jahren liegt der Kram im Keller. Sie kommen nicht dazu. Sie kommen nie dazu. Dafür gibt\'s uns.',
      'Wir räumen aus, sortieren, entsorgen fachgerecht – und kehren aus. In einem Zug. Keine Vorbereitung nötig. Nichts ausräumen. Einfach Schlüssel übergeben.',
    ],
    listItems: [
      'Alles raus – Möbel, Sperrmüll, Elektroschrott, jahrelanger Hausrat',
      'Dachboden & schwer zugängliche Bereiche – kein Problem',
      'Sortenreine Trennung und fachgerechte Entsorgung',
      'Wertgegenstände werden Ihnen übergeben oder angerechnet',
      'Besenrein gefegt – und fertig',
    ],
    imageSrc: P.garbageTruck,
    imageAlt: 'Kellerräumung Wien – fachgerechte Entsorgung',
  },
  benefits: [
    { icon: <Archive size={22} />, title: 'Günstig ab €290', desc: 'Kleinere Keller und Abstellräume schon ab €290 – Fixpreis nach Besichtigung.' },
    { icon: <Clock size={22} />, title: 'Kurzfristig', desc: 'Oft noch am selben oder nächsten Tag – Kellerräumungen werden schnell abgewickelt.' },
    { icon: <Shield size={22} />, title: 'Fixpreisgarantie', desc: 'Verbindlicher Preis nach Besichtigung – keine Überraschungen.' },
    { icon: <CheckCircle size={22} />, title: 'Besenrein', desc: 'Keller wird nach der Räumung gefegt und besenrein übergeben.' },
  ],
  process: [
    { icon: <MessageCircle size={24} />, title: 'Anfrage & Terminvereinbarung', desc: 'Formular ausfüllen oder anrufen. Für kleine Keller oft sofort ein Preis per Foto möglich.' },
    { icon: <Calendar size={24} />, title: 'Besichtigung & Fixpreis', desc: 'Kurzfristiger Besichtigungstermin – verbindliches Angebot noch vor Ort.' },
    { icon: <CheckCircle size={24} />, title: 'Räumung & besenreine Übergabe', desc: 'Schnelle Kellerräumung mit sauberer Übergabe – alles aus einer Hand.' },
  ],
  pricing: [
    { label: 'Kleiner Keller / Abstellraum', price: 'ab €290', icon: <Archive size={20} />, highlight: true },
    { label: 'Großer Keller / Dachboden', price: 'ab €490', icon: <Home size={20} />, highlight: false },
    { label: 'Mehrere Kellereinheiten', price: 'auf Anfrage', icon: <Building2 size={20} />, highlight: false },
  ],
  faq: [
    { q: 'Was kostet eine Kellerräumung in Wien?', a: 'Kleiner Keller ab €290. Größere Keller oder Dachböden ab €490. Genauen Preis erhalten Sie nach der kostenlosen Besichtigung – verbindlich und ohne Aufschläge.' },
    { q: 'Wie lange dauert das?', a: 'Kleiner Keller: oft ein halber Tag. Größerer Keller oder Dachboden: ein voller Tag. Wir sagen Ihnen nach der Besichtigung genau, was Sie erwarten können.' },
    { q: 'Was passiert mit dem ganzen Zeug?', a: 'Sortenrein getrennt und fachgerecht entsorgt – Holz, Metall, Elektroschrott, Plastik. Wertgegenstände bekommen Sie vorher. Den Rest nehmen wir mit.' },
    { q: 'Auch schwer zugängliche Keller?', a: 'Schmale Treppen, kein Lift, enge Abteile – das ist unser Alltag. Wir haben das passende Equipment für jeden Zugang.' },
    { q: 'Muss ich vorher etwas vorbereiten oder sortieren?', a: 'Nein. Nichts ausräumen, nichts sortieren, nichts vorbereiten. Wir nehmen alles so wie es ist. Das ist unser Job.' },
  ],
  relatedServices: [
    { title: 'Wohnungsräumung', slug: '/wohnungsraeumung-wien', icon: <Home size={18} /> },
    { title: 'Haushaltsauflösung', slug: '/haushaltsaufloesung-wien', icon: <Archive size={18} /> },
    { title: 'Nachlassräumung', slug: '/nachlassraeumung-wien', icon: <CheckCircle size={18} /> },
    { title: 'Messie-Wohnung', slug: '/messie-wohnung-wien', icon: <Building2 size={18} /> },
  ],
};

export default function KellerraeumungPage() {
  return <ServicePageLayout data={data} />;
}
